document.addEventListener("DOMContentLoaded", function () {

    const swiperCollectionSearch = new Swiper('.swiper-collection-search', {
        spaceBetween: 20,
        pagination: {
            el: '.swiper-collection-search-pagination.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next.swiper-collection-search-btns__next',
            prevEl: '.swiper-button-prev.swiper-collection-search-btns__prev',
        },
        breakpoints: {
            375: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            560: {
                slidesPerView: 4,
            }
        }
    });

});
